export default "__VITE_ASSET__CCChhlp$__"